var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 739 427.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00784d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.83,125.6a26.58,26.58,0,0,0-1.14-16.13c-10-23.92-57.47-26.83-106-6.5s-79.66,56.22-69.63,80.14c6.31,15,27.4,21.77,54.25,19.64-10.25,24-11.51,45.16-1.36,55.25,11.34,11.28,33.93,5.79,57.62-11.71,3.7,11.61,9.52,19.62,17.07,22,18.7,5.86,40.87-25.13,49.52-69.21,4.35-22.21,4.44-43.5,1.07-59.91A40.25,40.25,0,0,0,296.83,125.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M583,156.17a19.74,19.74,0,0,0-10.19-6.33c-18.73-4.38-41.12,22.84-50,60.81s-.9,72.3,17.83,76.68c11.78,2.76,25-7,35.4-24,10,16.59,22.11,26.56,32.59,24.85,11.71-1.9,18.24-17.86,18-39.69,8.58,2.82,15.93,2.81,20.64-.69,11.65-8.68,2.69-35.48-20-59.85-11.45-12.28-24.19-21.59-35.52-26.71A30.06,30.06,0,0,0,583,156.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.46,68.32a26.48,26.48,0,0,0-13.91-8.26c-25.37-5.4-54.81,31.91-65.76,83.33s.75,97.5,26.12,102.9c15.95,3.39,33.51-10.1,47.07-33.36,13.86,22.1,30.53,35.21,44.61,32.62,15.73-2.88,24.1-24.57,23.24-54,11.64,3.58,21.55,3.36,27.8-1.49,15.48-12,2.67-47.9-28.62-80.14-15.76-16.24-33.19-28.46-48.6-35A40.26,40.26,0,0,0,346.46,68.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M536.21,96.22a26.5,26.5,0,0,0-5-15.36c-15.56-20.75-62.28-12-104.35,19.54s-63.54,73.94-48,94.69c9.78,13,31.88,14.43,57.4,5.83-4.09,25.75-.16,46.59,12.15,53.91,13.75,8.17,34.32-2.67,53-25.41,6.42,10.35,14,16.7,21.92,17.16,19.57,1.13,33.51-34.33,31.15-79.2-1.19-22.59-6.3-43.26-13.57-58.36A40.35,40.35,0,0,0,536.21,96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.35,204.43S53.6,310,98.3,354.06c0,0,77-34.61,86.37-107.25s-12-75.34-12-75.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.65,288.15s18.93,43.09,42.64,67.05c0,0,42.81-88.35,11.26-139.69s-56.45,10.66-56.45,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.72,199.25s292.4-284.7,378.14-48.19l3.19,51.65-308.3-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.73,83.51c-64.28-91.66-92.49,12.27-92.49,12.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.35,204.43s-36.14-65.34,35.25-62.3S155,202.71,155,202.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.24,163.57S657,86.17,651,201.17l-44.9,25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "380.59 0 439.29 9.64 391.92 88.61 381.46 119.1 357.09 96.63 380.59 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.9 70.75 114.71 0 160 149.38 98.59 226.17 0 84.16 18.9 70.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "720.11 70.75 624.3 0 579 149.38 640.41 226.17 739 84.16 720.11 70.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "89.66 336.16 64.38 427.62 128.37 333.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "641.71 341.7 690.98 422.8 666.34 311.73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset8);
export default __webpack_public_path__ + "static/media/Asset 8.5e77205f.svg";
export { ForwardRef as ReactComponent };